import _Option2 from "element-ui/lib/theme-chalk/option.css";
import "element-ui/lib/theme-chalk/base.css";
import _Option from "element-ui/lib/option";
import _Select2 from "element-ui/lib/theme-chalk/select.css";
import "element-ui/lib/theme-chalk/base.css";
import _Select from "element-ui/lib/select";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import Vue from "vue";
Vue.use(_Select);
Vue.use(_Option);
export default {
  props: {
    typeList: {
      type: Array,
      default: () => []
    }
  },
  name: "ChangeHuashuTypeDialog",
  data() {
    return {
      pageWidth: document.documentElement.clientWidth,
      pageHeight: document.documentElement.clientHeight,
      options: this.typeList.map(type => {
        let labelName = type.labelName.substring(0, 10);
        if (type.labelName.length > 10) {
          labelName += "...";
        }
        return {
          value: type.labelId,
          label: labelName
        };
      }),
      value: ""
    };
  },
  mounted() {
    console.log("typeList:", this.typeList);
  },
  methods: {
    save() {
      if (!this.value) {
        return;
      }
      this.$emit("save", this.value);
    },
    cancel() {
      this.$emit("cancel");
    },
    dialogCoverClick() {}
  }
};